import { GlobalState } from '../reducers';

export const getSignInMessage = (state: GlobalState) => state.signIn.signInMessage;